import React from 'react';
import './style.css'

const Scrollbar = () => {

    return (
        <><ul className="smothscroll">
            <li><a href='#scrool' aria-label="Scroll to top"><i className="ti-arrow-up"></i></a></li>
        </ul><a
            href="https://wa.me/+447466436417"
            target="_blank"
            className="whatsapp-float"
            title="Chat with Us"
            rel="noopener noreferrer"
        >
                <i className="fab fa-whatsapp"></i>
            </a></>

    )
}

export default Scrollbar;
